import { EventType } from './../models/request-round/request-record.interface';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventTypeTranslate',
  standalone:true
})
export class EventTypeTranslatePipe implements PipeTransform {
  transform(value: EventType | string): string {
    switch (value) {
      case EventType.REPLACEMENT:
      case 'REPLACEMENT':
        return 'Sostituzione';
      case EventType.USAGE:
      case 'USAGE':
        return 'Utilizzo';
      case EventType.TRIAL:
      case 'TRIAL':
        return 'Periodo di prova';
      case EventType.ACTIVATION:
      case 'ACTIVATION':
        return 'Attivazione';
      case EventType.ABSENCE:
      case 'ABSENCE':
        return 'Assenza Ingiustificata';
      default:
        return value;
    }
  }
}
